/* eslint-disable max-len */
import * as React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

export const VacationAndTimeOffIcon = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg viewBox="0 0 20 18.03" fill="none" aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M17.15,6.46a1,1,0,0,0,.36-.23,1,1,0,0,0,.21-.37.9.9,0,0,0,0-.43A.88.88,0,0,0,17.56,5,9.07,9.07,0,0,0,1.4,10.66a.87.87,0,0,0,.1.42.79.79,0,0,0,.28.32.83.83,0,0,0,.4.16.75.75,0,0,0,.42,0Z" fill="#d8f0e9" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.94.5l.44,1.21" fill="none" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.43,13.57l-1-2.84L10,9.32" fill="none" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M.5,16.6a4.44,4.44,0,0,0,2-.19,4.43,4.43,0,0,0,1.67-1,3.66,3.66,0,0,0,1.23.9,3.82,3.82,0,0,0,1.49.31,3.74,3.74,0,0,0,1.48-.31,3.66,3.66,0,0,0,1.23-.9,3.87,3.87,0,0,0,1.23.9,3.74,3.74,0,0,0,3,0,3.76,3.76,0,0,0,1.23-.9,4.38,4.38,0,0,0,3.62,1.21" fill="none" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
